import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BsusResult } from '../models/bsus-result.model';
import { Software } from '../models/software.model';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private readonly http: HttpClient) {}
 
  public getSoftwareWithDownloadUrl(softwareId: string): Observable<Software> {
    const path = `${environment.backend}update/download?id=${softwareId}`;

    return this.http.get<BsusResult<Software>>(path).pipe(
      map((next) => next.result[0])
    );
  }
}
